import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Stack } from '@famly/mf_layout_stack';
import { SplitModalContext } from './split-modal';
const CONTENT_RIGHT_STYLES = {
    contextual: {
        padding: '24px 24px 0px 24px',
    },
    fullModal: {},
};
/**
 * Contextual content area, grey (n50) background by default or optionally white (n0).
 * Use for help text, summaries, progress indicators.
 * In contextual variant, includes footer positioning. FullModal variant uses standard layout.
 *
 * @param children - Content for the right area
 * @param backgroundColor - 'n50' (grey, default) or 'n0' (white)
 * @example
 * ```tsx
 * <SplitModalContentRight>
 *   <Stack gap={2}>
 *     <Text variant="h6">Help & Tips</Text>
 *     <Text>Fill out all required fields...</Text>
 *   </Stack>
 * </SplitModalContentRight>
 * ```
 */
export const SplitModalContentRight = ({ children, backgroundColor = 'n50', ...props }) => {
    const context = React.use(SplitModalContext);
    if (!(context === null || context === void 0 ? void 0 : context.variant)) {
        return null;
    }
    const rightContentStyle = CONTENT_RIGHT_STYLES[context.variant] || {};
    return (_jsx(Stack, { component: "div", ...props, style: { gridArea: 'right' }, backgroundColor: backgroundColor, borderLeft: "n100", padding: "24px", display: "flex", flexDirection: "column", justifyContent: "space-between", maxHeight: "100%", overflow: "auto", minHeight: 0, ...rightContentStyle, children: children }));
};
